import {
  AuthState,
  BookingState,
  ClubState,
  ProductState,
  CategoryState,
  CourtState,
  RootState,
  UserState,
  BranchState,
  AppState
} from "../../types";

const getAuthState = (state: RootState): AuthState => state.authState;
const getClubState = (state: RootState): ClubState => state.clubState;
const getProductState = (state: RootState): ProductState => state.productState;
const getCategoryState = (state: RootState): CategoryState => state.categoryState;
const getUserState = (state: RootState): UserState => state.userState;
const getCourtState = (state: RootState): CourtState => state.courtState;
const getBookingState = (state: RootState): BookingState => state.bookingState;
const getBranchState = (state: RootState): BranchState => state.branchState;
const getAppState = (state: RootState): AppState => state.appState;

export {
  getAuthState,
  getClubState,
  getProductState,
  getCategoryState,
  getUserState,
  getCourtState,
  getBookingState,
  getBranchState,
  getAppState,
};
